<p-chart #chart type="bar" [data]="chartData" [options]="chartOptions" class="summary-chart"></p-chart>
<cc-exchange-buttons [exchangeCodes]="availableExchanges" [selectedExchangeCode]="selectedExchangeCode"
                     (selectedExchangeChange)="selectExchange($event)"> </cc-exchange-buttons>
